export default "/images/vendor/@coreui/icons/svg/flag/cif-tw.svg?35196b6de2ca08e2130de011ae2ce620";